export default {
  name: 'UserInfoHeader',
  computed: {},
  methods: {}
};
